import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22fonts.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22./assets/fonts/font/300.woff2%22,%22weight%22:%22100%22,%22style%22:%22normal%22},{%22path%22:%22./assets/fonts/font/400.woff2%22,%22weight%22:%22200%22,%22style%22:%22normal%22},{%22path%22:%22./assets/fonts/font/500.woff2%22,%22weight%22:%22300%22,%22style%22:%22normal%22}],%22variable%22:%22--font-wide%22,%22display%22:%22block%22}],%22variableName%22:%22wide%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'wide', 'wide Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
